import React, { Component } from 'react';

import GoalsCardItem from './GoalsCardItem';

export default class GoalsViewHome extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {
            goalVisibleMode: 'home', // home, ca, locs, loc, emplocs, emps, emp
            goalFilter: { location: null, employee: null },
            backStack: [],
            transitionMode: false
        }

        this.goBack = this.goBack.bind(this);
        this.setGoalOptions = this.setGoalOptions.bind(this);

        this.getLocationMap = this.getLocationMap.bind(this);
        this.getUserMap = this.getUserMap.bind(this);

        this.filterGoal = this.filterGoal.bind(this);

        this.generateGoalItems = this.generateGoalItems.bind(this);
        this.generateVisibleGoals = this.generateVisibleGoals.bind(this);
        this.generateModeOptions = this.generateModeOptions.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    goBack() {
        let self = this;
        if (!self.state.transitionMode) {
            self.setState({ transitionMode: true }, () => {
                let backStack = self.state.backStack;
                let backItem = backStack.pop();

                setTimeout(() => {
                    self.setState({ goalVisibleMode: backItem.goalVisibleMode, goalFilter: backItem.goalFilter, backStack: backStack, transitionMode: false });
                }, 250);
            });
        }
    }

    setGoalOptions(mode, locFilter, empFilter) {
        let self = this;
        if (!self.state.transitionMode) {
            self.setState({ transitionMode: true }, () => {
                let backStack = self.state.backStack;
                backStack.push({
                    goalVisibleMode: self.state.goalVisibleMode,
                    goalFilter: self.state.goalFilter
                });

                setTimeout(() => {
                    self.setState({ goalVisibleMode: mode, goalFilter: { location: locFilter, employee: empFilter }, backStack: backStack, transitionMode: false });
                }, 250);
            });
        }
    }

    getLocationMap() {
        return this.props.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.reduce((r, e) => {
            let key = e.locationID;
            if (!r[key]) {
                r[key] = e.name;
            }
            return r;
        }, {});
    }

    getUserMap() {
        return this.props.users.reduce((r, e) => {
            let key = e.userId;
            if (!r[key]) {
                r[key] = e.fullName;
            }
            return r;
        }, {});
    }

    filterGoal(goal) {
        return (goal.locationId === this.state.goalFilter.location && goal.userId === this.state.goalFilter.employee)
    }

    generateGoalItems(goalList, category) {
        let goalJsxList = [];

        goalList.forEach((goal) => {
            if (this.filterGoal(goal)) {
                goalJsxList.push((
                    <GoalsCardItem
                        category={category}
                        identity={goal}
                        handleDelete={this.props.handleDelete}
                        handleArchive={this.props.handleArchive}
                        isActive={goal.goalId === this.props.selectedGoalId}
                        handleSelectGoal={this.props.handleSelectGoal}
                        handleModeChange={this.props.handleModeChange}
                        startEditGoal={this.props.startEditGoal}
                        startResultsGoal={this.props.startResultsGoal}
                    />
                ));
            }
        });

        return goalJsxList;
    }

    generateVisibleGoals() {
        let goalsObj = this.props.goalsObj;

        //old
        let activeClientAccountGoals = this.generateGoalItems(goalsObj.active.clientAccount, 'active');
        let activeLocationGoals = this.generateGoalItems(goalsObj.active.location, 'active');
        let activeUserGoals = this.generateGoalItems(goalsObj.active.user, 'active');

        let completeClientAccountGoals = this.generateGoalItems(goalsObj.complete.clientAccount, 'complete');
        let completeLocationGoals = this.generateGoalItems(goalsObj.complete.location, 'complete');
        let completeUserGoals = this.generateGoalItems(goalsObj.complete.user, 'complete');

        let archiveGoals = this.generateGoalItems(goalsObj.archive, 'archive');

        let result = [];

        result.push((<div className="material-icons gc-add-button" onClick={this.props.startNewGoal}>add</div>));
        result.push((<div className="gc-category-back-button" onClick={this.goBack}>{"Back"}</div>));
        result.push(((activeClientAccountGoals.length > 0 || activeLocationGoals.length > 0 || activeUserGoals.length > 0) ?
            ([
                (
                    <div className="gc-major-label">Active</div>
                ), (
                    <div className="settings-central-regular-card-container">
                        {
                            (activeClientAccountGoals.length > 0) ?
                                ([
                                    (
                                        <div className="settings-central-regular-card-label">Company Wide</div>
                                    ), (
                                        activeClientAccountGoals
                                    )
                                ]) : null
                        }
                        {
                            (activeLocationGoals.length > 0) ?
                                ([
                                    (
                                        <div className="settings-central-regular-card-label">Location</div>
                                    ), (
                                        activeLocationGoals
                                    )
                                ]) : null
                        }
                        {
                            (activeUserGoals.length > 0) ?
                                ([
                                    (
                                        <div className="settings-central-regular-card-label">Employee</div>
                                    ), (
                                        activeUserGoals
                                    )
                                ]) : null
                        }
                    </div>
                )
            ]) : null));
        result.push(((completeClientAccountGoals.length > 0 || completeLocationGoals.length > 0 || completeUserGoals.length > 0) ?
            ([
                (
                    <div className="gc-major-label">Complete</div>
                ), (
                    <div className="settings-central-regular-card-container">
                        {
                            (completeClientAccountGoals.length > 0) ?
                                ([
                                    (
                                        <div className="settings-central-regular-card-label">Company Wide</div>
                                    ), (
                                        completeClientAccountGoals
                                    )
                                ]) : null
                        }
                        {
                            (completeLocationGoals.length > 0) ?
                                ([
                                    (
                                        <div className="settings-central-regular-card-label">Location</div>
                                    ), (
                                        completeLocationGoals
                                    )
                                ]) : null
                        }
                        {
                            (completeUserGoals.length > 0) ?
                                ([
                                    (
                                        <div className="settings-central-regular-card-label">Employee</div>
                                    ), (
                                        completeUserGoals
                                    )
                                ]) : null
                        }
                    </div>
                )
            ]) : null));
        result.push(((archiveGoals.length > 0) ?
            ([
                (
                    <div className="gc-major-label">Archive</div>
                ), (
                    <div className="settings-central-regular-card-container">
                        {archiveGoals}
                    </div>
                )
            ]) : null));
        result.push((<div className="spacer-2"></div>));

        return result;
    }

    generateModeOptions() {
        let result = [];

        result.push((<div className="material-icons gc-add-button" onClick={this.props.startNewGoal}>add</div>));
        result.push((<div className={"gc-category-back-button" + (this.state.goalVisibleMode === 'home' ? ' hidden' : '')} onClick={this.goBack}>{"Back"}</div>));

        let cardOptions = [];
        let cardOptionsHeader = "";

        switch (this.state.goalVisibleMode) {
            case "home":
                cardOptions.push((<div className="settings-card-item-category" onClick={this.setGoalOptions.bind(null, 'ca', null, null)}>Client Account</div>));
                cardOptions.push((<div className="settings-card-item-category" onClick={this.setGoalOptions.bind(null, 'locs', null, null)}>Location</div>));
                cardOptions.push((<div className="settings-card-item-category" onClick={this.setGoalOptions.bind(null, 'emplocs', null, null)}>Employee</div>));
                cardOptionsHeader = "Categories";
                break;
            case "locs":
                let locationMapA = this.getLocationMap();
                let visibleLocationsA = this.props.goals.reduce((r, e) => {
                    let key = e.locationId;
                    if (!r.d[key] && key != null && e.userId === null) {
                        r.d[key] = true;
                        r.l.push({ id: key, name: locationMapA[key] });
                    }
                    return r;
                }, { d: {}, l: [] }).l;
                _.sortBy(visibleLocationsA, (obj) => { return obj.name }).forEach(loc => {
                    cardOptions.push((<div className="settings-card-item-category" onClick={this.setGoalOptions.bind(null, 'loc', loc.id, null)}>{loc.name}</div>));
                });
                cardOptionsHeader = "Locations";
                break;
            case "emplocs":
                let locationMapB = this.getLocationMap();
                let visibleLocationsB = this.props.goals.reduce((r, e) => {
                    let key = e.locationId;
                    if (!r.d[key] && key != null && e.userId != null) {
                        r.d[key] = true;
                        r.l.push({ id: key, name: locationMapB[key] });
                    }
                    return r;
                }, { d: {}, l: [] }).l;
                _.sortBy(visibleLocationsB, (obj) => { return obj.name }).forEach(loc => {
                    cardOptions.push((<div className="settings-card-item-category" onClick={this.setGoalOptions.bind(null, 'emps', loc.id, null)}>{loc.name}</div>));
                });
                cardOptionsHeader = "Employee Locations";
                break;
            case "emps":
                let locationMapC = this.getLocationMap();
                let userMap = this.getUserMap();
                let visibleEmployees = this.props.goals.reduce((r, e) => {
                    let key = e.userId;
                    if (!r.d[key] && e.locationId === this.state.goalFilter.location && e.userId != null) {
                        r.d[key] = true;
                        r.l.push({ id: key, name: userMap[key] });
                    }
                    return r;
                }, { d: {}, l: [] }).l;
                _.sortBy(visibleEmployees, (obj) => { return obj.name }).forEach(emp => {
                    cardOptions.push((<div className="settings-card-item-category" onClick={this.setGoalOptions.bind(null, 'emp', this.state.goalFilter.location, emp.id)}>{emp.name}</div>));
                });
                cardOptionsHeader = locationMapC[this.state.goalFilter.location] + " Employees";
                break;
        }

        if (cardOptions.length > 0) {
            result.push((<div className={"gc-major-label"}>{cardOptionsHeader}</div>));
        }

        result.push((
            <div className={"settings-central-regular-card-container"}>
                {cardOptions}
            </div>
        ))

        result.push((<div className="spacer-2"></div>));

        return result;
    }

    render() {
        let goalsObj = this.props.goalsObj;

        let activeJsx = null;

        let vMode = this.state.goalVisibleMode;
        if (vMode === 'home' || vMode === 'locs' || vMode === 'emplocs' || vMode === 'emps') {
            activeJsx = this.generateModeOptions();
        } else {
            activeJsx = this.generateVisibleGoals();
        }

        return (
            <div className={this.props.className + (this.state.transitionMode ? ' transitioning' : '')} style={this.props.style}>
                {activeJsx}
            </div>
        );
    }
}